import { useTranslation } from 'react-i18next';

import { CheckboxField, type CheckboxFieldProps } from '../../fields/CheckboxField';
import type { DailyTasksFormFilerValue } from '../lib/types';

type AssignedToMeFieldProps = Omit<CheckboxFieldProps<DailyTasksFormFilerValue, 'isAssignedToMe'>, 'name' | 'label'>;
export const AssignedToMeField = (props: AssignedToMeFieldProps) => {
  const { t } = useTranslation();

  return <CheckboxField {...props} name='isAssignedToMe' label={t('assigned-to-me')} />;
};
